import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useTimezone } from '@/hooks';

interface TimeDisplayProps {
  className?: string;
  style?: React.CSSProperties;
}

const TimeDisplay: React.FC<TimeDisplayProps> = ({ className, style }) => {
  const [localTime, setLocalTime] = useState('');
  const tz = useTimezone();
  useEffect(() => {
    const intervalId = setInterval(() => {
      setLocalTime(dayjs().tz(tz).format('MMMM D, YYYY, h:mm A'));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [tz]);

  return (
    <span className={className} style={style}>
      {localTime} {tz}
    </span>
  );
};

export default TimeDisplay;
